import React, { useState, useEffect, Fragment, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { loadDocumentsOfConcept } from "../../actions/buildconceptActions"
import { makeStyles } from "@material-ui/core/styles"
import Modal from "@material-ui/core/Modal"
import { documentsActions } from "../../actions/documentsActions"
import { operationsHelper } from "../../helpers/operations"
import { documentsService } from "../../services/documents.services"
import { dataHelper } from "../../helpers/dataextraction"
import MetadataLayout from "../general/MetadataLayout"
import DocumentModal from "../common/DocumentModal"
import { sourceHelper } from "../../helpers/sourceHelper"
import Pagination from "../common/Pagination"
import BulkDownload from "../common/bulkDownload"
import PaginationInput from "../common/PaginationInput"
//import { relative } from "path"
import { Dropdown, DropdownButton } from "react-bootstrap"
import CommentsDetailsModal from "../documents/CommentsDetailsModal"
import CommentsList from "../documents/CommentsList"
import { ownerDocument } from "@material-ui/core"
import axios from "../../services/axios"
import { getCommentsCount, METADATA } from "../../utils"
import TagsUpdateDropdown from "../common/TagsUpdateDropdown"
import { getDocumentRowClickRequest } from "../../actions/documentModalActions"
import { updateSearchMetadata } from "../../actions/searchActions"

// import axios from 'axios';

const ElementsListSearch = ({
	elementsFilter,
	saveElementsFilter,
	filtersButton,
	filterList,
	filterDate,
	needToFilter,
	setNeedToFilter,
	tagsList,
}) => {
	/* ******************* REDUX STORE ******************* */
	//Redux actions
	const dispatch = useDispatch()
	const alert = useSelector((state) => state.alert.alert)
	const globalStateSearchDocumentList = useSelector((state) => state.search.searchResults)
	const conceptsOfSearch = useSelector((state) => state.search.concept_target_terms)
	const cargando = useSelector((state) => state.search.loading)
	const currentSearch = useSelector((state) => state.currentSearchs.search)
	const sourceApi = useSelector((state) => state.sources.docs_sources)
	const downloadDocs = useSelector((state) => state.downloads.documents)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const updateCommentsRequest = useSelector((state) => state.document.reloadComments)
	const comentsCount = useSelector((state) => state.document.doc_counts)
	// La variable de abajo (searchDocsData) se usará para controlar los comments y tags/custom tags de cada documento.
	// ahora mismo están pendientes de ser añadidos por anzyz.
	const searchDocsData = useSelector((state) => state.search.searchDocsData)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Data state
	const [searchDocumentsList, setSearchDocumentslist] = useState({ count: 0, data: [] })
	// State for manage the elements mouseOver
	const [itemId, setItemId] = useState()
	const [currentpage, setCurrentPage] = useState(1)
	const [totalpages, setTotalPages] = useState(1)
	// getModalStyle is not a pure function, we roll the style only on the first render
	const [modalStyle] = useState(getModalStyle)
	const [open, setOpen] = useState(false)
	const [selectIdentify, setSelectIdentify] = useState({
		show: false,
		value: "",
		elementId: "",
		color: "",
	})
	const [selectDateDocument, setSelectDateDocument] = useState({
		show: false,
		date: "",
		elementId: "",
	})
	// Get Item Content
	const [item, setItem] = useState({
		idItem: "",
		contentItem: "",
		source: "",
		date: "",
		commentsCount: 0,
		comments: "",
	})

	// Select MouseOver / MouseOut
	const [selectOver, setSelectOver] = useState(false)
	//Current hightlight text word index
	const [hightlightIndex, setHightlightIndex] = useState(null)

	// Get document content
	const [content, setContent] = useState({
		documentId: "",
		documentText: "",
		documentSubject: "",
		documentFrom: "",
		documentTo: "",
		errorDocumentText: null,
	})

	//Docs to show - Pagination
	const [docsToSHow, setDocsToSHow] = useState({ count: 0, data: [] })
	// Refresh elements list
	const [refreshElementsList, setRefreshElementsList] = useState(0)
	// BULK BUTTONS
	const [activeCheckbox, setActiveCheckbox] = useState(false)
	// Bulk checked
	const [bulkChecked, setBulkChecked] = useState(new Array(docsToSHow.data.length).fill(false))
	// Documents selected - Bulk download
	const [documentsBulk, setDocumentsBulk] = useState([])
	// All selected
	const [allChecked, setAllChecked] = useState(false)

	const [showingCommentBox, setShowingCommentBox] = useState(false)
	const [showingCommentBoxId, setShowingCommentBoxId] = useState(null)

	//Docs Comments
	const [comment, setComment] = useState("")
	const [commentList, setCommentList] = useState([])
	const [commentContent, setCommentContent] = useState()

	// Refresh element
	const [idElement, setIdElement] = useState(Math.random())

	/* ******************* END REACT STATES ******************* */

	/* ******************* VARIABLES INITIALIZATION ******************* */
	//DB click control
	let timer = 0
	let delay = 200
	let prevent = false
	// Pagination
	let elementsPerPage = 20
	let calcTotalPages = Math.ceil(searchDocumentsList.data.length / elementsPerPage)
	/* ******************* END VARIABLES INITIALIZATION ******************* */

	/* ******************* USE-EFFECTS ******************* */
	useEffect(() => {
		setActiveCheckbox(false)
	}, [selectedBaseId])
	//Reload comments when updating
	useEffect(() => {
		if (updateCommentsRequest === true) {
			updateCommentList(showingCommentBoxId)
			dispatch(documentsActions.updateCommentRequest(false))
		}
	}, [updateCommentsRequest])

	//Close date modal when success
	useEffect(() => {
		if (alert && alert.type === "modal" && alert.class === "alert alert-success") {
			if (selectDateDocument.date) {
				setItem({ ...item, date: new Date(selectDateDocument.date).getTime() })
			}
			setSelectDateDocument({
				show: false,
			})
		}
	}, [alert])

	useEffect(() => {
		filtering()
		return
	}, [globalStateSearchDocumentList, elementsFilter, filtersButton, filterList, filterDate])

	useEffect(() => {
		if (needToFilter === true) {
			filtering()
			setNeedToFilter(false)
		}

		return
	}, [needToFilter])

	useEffect(() => {
		setSearchDocumentslist(globalStateSearchDocumentList)
		filtering()
		return
	}, [globalStateSearchDocumentList])

	useEffect(() => {
		setTotalPages(calcTotalPages)
		setCurrentPage(1)
		return
	}, [calcTotalPages])

	//Update number of elements shown in list
	useEffect(() => {
		var elements = document.getElementsByClassName("conceptLoaded")
		for (var i = 0; i < elements.length; i++) {
			if (elements[i].classList.contains("conceptLoaded_page_" + currentpage) === true) {
				elements[i].classList.remove("hidePage")
			} else {
				elements[i].classList.add("hidePage")
			}
		}
	}, [currentpage])

	useEffect(() => {
		if (searchDocumentsList.count > 0) {
			//Check if content exclide filter is active
			let auxToShow = searchDocumentsList.data.filter((elementoDoc) =>
				operationsHelper.hideForSpecificWord(
					elementoDoc.content,
					filtersButton.specificWordExclude,
					filtersButton.searchWordExclude
				) === false
					? elementoDoc
					: null
			)
			auxToShow = auxToShow.slice(20 * (currentpage - 1), 21 * currentpage - currentpage)
			setDocsToSHow({
				count: auxToShow.length,
				data: auxToShow,
			})
		} else {
			setDocsToSHow({
				count: 0,
				data: [],
			})
		}
	}, [searchDocumentsList, currentpage, filtersButton.specificWordExclude, filtersButton.searchWordExclude])

	useEffect(() => {
		if (selectIdentify.elementId !== undefined && selectIdentify.elementId !== "") {
			try {
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-warning")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-danger")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("text-success")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).classList.remove("circleHidden")
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.backgroundColor = operationsHelper.getTagColor(
					selectIdentify.value,
					tagsApi
				)
				document.getElementById(`doc_id_${selectIdentify.elementId}`).style.display = "block"
			} catch (e) {}
		}
	}, [selectIdentify])

	useEffect(() => {
		commentList.forEach((item) => {
			if (item.doc_id === showingCommentBoxId) {
				setCommentContent(item)
			}
		})
	}, [showingCommentBoxId, commentList])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	// UPDATE DATA FILTER
	const filtering = () => {
		let newData = operationsHelper.filteringDocsBayTag(globalStateSearchDocumentList, elementsFilter["coloursFilter"])
		setSearchDocumentslist({
			count: newData.length,
			data: newData,
		})
	}

	//Previous Page
	const prevPage = () => {
		const newCurrentPage = currentpage - 1
		if (newCurrentPage === 0) return
		setCurrentPage(newCurrentPage)
	}

	// Next Page
	const nextPage = () => {
		const newCurrentPage = currentpage + 1
		if (newCurrentPage > totalpages) return
		setCurrentPage(newCurrentPage)
	}

	// MODAL ELEMENT
	function rand() {
		return Math.round(Math.random() * 20) - 10
	}

	function getModalStyle() {
		const top = 0
		const left = 60

		return {
			top: `${top}%`,
			left: `${left}%`,
			//transform: `translate(-${top}%, -${left}%)`,
		}
	}

	const useStyles = makeStyles((theme) => ({
		paper: {
			position: "absolute",
			width: "40%",
			height: "100%",
			backgroundColor: "#9dddd6",
			//border: '2px solid #000',
			boxShadow: theme.shadows[5],
			padding: "16px 15px 24px",
		},
	}))

	const handleOpen = () => {
		setOpen(true)
		setHightlightIndex(null)
	}

	const handleClose = () => {
		setOpen(false)
		setSelectIdentify({ ...selectIdentify, show: false })
		setSelectDateDocument({ ...selectDateDocument, show: false })
		setHightlightIndex(null)
		setShowingCommentBoxId(null)
	}

	const showSelectIdentify = (e) => {
		e.preventDefault()
		if (!selectIdentify.show) {
			setSelectIdentify({
				show: true,
			})
			setSelectDateDocument({
				show: false,
			})
		} else {
			setSelectIdentify({
				show: false,
			})
		}
	}
	const updateSelectIdentify = (tag_id, elementId) => {
		try {
			dispatch(documentsActions.setPriorityAction(elementId, tag_id))
			setSelectIdentify({
				value: tag_id,
				elementId: elementId,
			})
		} catch (e) {
			console.log(e)
		}
	}

	const showSelectDateDocument = (e) => {
		e.preventDefault()
		if (!selectDateDocument.show) {
			setSelectDateDocument({
				show: true,
			})
			setSelectIdentify({
				show: false,
			})
		} else {
			setSelectDateDocument({
				show: false,
			})
		}
	}

	const updateSelectDateDocument = (e, docId) => {
		e.preventDefault()
		setSelectDateDocument({
			show: true,
			date: e.target.value,
			elementId: docId,
		})
	}

	const updateDateDocument = (e) => {
		e.preventDefault()
		dispatch(documentsActions.setDocumentDateAction(selectDateDocument.elementId, selectDateDocument.date))
	}

	// Get dates with yellow marked background
	const maskHightlight = (text, id) => {
		let markedText = operationsHelper.cleanHTMLTags(text)
		if (filtersButton.emails === true) {
			markedText = operationsHelper.highlightEmails(markedText, id)
		}

		if (filtersButton.concepts === true) {
			markedText = operationsHelper.highlightConcepts(markedText, conceptsOfSearch, id, currentSearch.text)
		}

		if (filtersButton.dates !== false) {
			markedText = operationsHelper.hightlightDates(markedText, id)
		}

		if (filtersButton.searchWord.length !== 0 && filtersButton.specificWord === true) {
			markedText = operationsHelper.highlightWords(markedText, filtersButton.searchWord, id)
		}

		return { __html: markedText }
	}

	// OUTSIDE ALERTER
	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setSelectIdentify({ show: false })
					setSelectDateDocument({ show: false })
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	//Scroll to next hightlight word
	const moveToHightlight = () => {
		try {
			var elementMark = document.getElementsByClassName("mark_element")
			var nextH
			if (hightlightIndex === null) {
				nextH = 0
			} else {
				nextH = (hightlightIndex + 1) % elementMark.length
			}
			setHightlightIndex(nextH)
			document.getElementById("divModal").scrollTop = elementMark[nextH].offsetTop - 100
		} catch (e) {}
	}

	// Get document content from API
	// const getDocumentContent = (idDocument) => {
	//     try {
	//         var documentContent = documentsService.downloadDocumentContent(idDocument);
	//         dataHelper.extractData(documentContent,setContent,globalStateSearchDocumentList,idDocument);

	//     } catch (error) {

	//     }
	// }

	const getDocumentContent = (idDocument, documentContent) => {
		try {
			dataHelper.extractData(documentContent, setContent, globalStateSearchDocumentList, idDocument)
		} catch (error) {}
	}

	const handleChange = (position) => {
		const updatedCheckedState = bulkChecked.map((item, index) => {
			if (index === position) {
				return !item
			} else {
				return item
			}
		})

		setBulkChecked(updatedCheckedState)
	}

	const handleChangeAll = (active) => {
		if (active) {
			setAllChecked(false)
		} else {
			setAllChecked(true)
		}
	}

	const updateDocumentsBulk = (docId, filename) => {
		let document = {
			id: docId,
			filename: filename,
		}

		let deleteDocument = false
		let indexDoc = ""

		Object.keys(documentsBulk).map((key, index) => {
			if (documentsBulk[key].id === docId) {
				deleteDocument = true
				indexDoc = index
			}
		})

		if (deleteDocument) {
			documentsBulk.splice(indexDoc, 1)
		} else {
			documentsBulk.push(document)
		}
	}

	const selectAllDocs = () => {
		if (allChecked) {
			setBulkChecked(new Array(docsToSHow.data.length).fill(false))

			let deleteDocument = false
			let indexDoc = ""

			docsToSHow.data.map((item, i) => {
				Object.keys(documentsBulk).map((key, index) => {
					if (documentsBulk[key].id === item.id) {
						deleteDocument = true
						indexDoc = index
					}
				})

				if (deleteDocument) {
					documentsBulk.splice(indexDoc, 1)
				}
			})
		} else {
			setBulkChecked(new Array(docsToSHow.data.length).fill(true))

			docsToSHow.data.map((item, i) => {
				let document = {
					id: item.id,
					filename: item.title,
				}
				documentsBulk.push(document)
			})
		}
	}

	const onChangeCommentInput = (e) => {
		setComment(e.target.value)
	}

	const updateCommentList = async (docId) => {
		//get comment list form backend
		setCommentList([])
		//const response = await documentsService.getComments(docId);
		const response = await axios.get(`/documents/comments/${docId}`)
		if (response.hasOwnProperty("data") && response.data.hasOwnProperty("data")) {
			setCommentList(response.data.data)
			dispatch(documentsActions.storeCommentCountRequest(docId, response.data.data.length))

			const data = {}
			data[METADATA.COMMENT] = response.data.data.length
			dispatch(updateSearchMetadata({ id: docId, data: data }))
		}

		return
	}

	const updateCommentContent = (docId) => {
		commentList.forEach((item) => {
			if (item.docId === docId) {
				setCommentContent(item)
			}
		})
	}

	const handleRecordClick = async (id) => {
		dispatch(getDocumentRowClickRequest(id))
	}

	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	const classes = useStyles()
	const wrapperRef = useRef(null)
	useOutsideAlerter(wrapperRef)
	/* ******************* END VARIABLES ******************* */

	return (
		<div key={refreshElementsList} className="section mt-5 componentContainer">
			<Fragment>
				<PaginationInput
					currentpage={currentpage}
					totalpages={totalpages}
					docsToSHow={docsToSHow}
					setCurrentPage={setCurrentPage}
					setDocumentsBulk={setDocumentsBulk}
					setAllChecked={setAllChecked}
				/>

				{docsToSHow.count > 0 ? (
					<BulkDownload
						docsToSHow={docsToSHow}
						activeCheckbox={activeCheckbox}
						setActiveCheckbox={setActiveCheckbox}
						bulkChecked={bulkChecked}
						setBulkChecked={setBulkChecked}
						documentsBulk={documentsBulk}
						setDocumentsBulk={setDocumentsBulk}
						allChecked={allChecked}
						setAllChecked={setAllChecked}
					/>
				) : null}

				{activeCheckbox ? (
					<div>
						<label style={{ paddingRight: "8px" }}>Select All</label>
						<input
							key={`bulk_checkbox_all`}
							type="checkbox"
							checked={allChecked}
							className="form-check-input"
							onChange={(e) => {
								e.preventDefault()
								handleChangeAll(allChecked)
							}}
							onClick={(e) => {
								e.preventDefault()
								selectAllDocs()
							}}
						></input>
					</div>
				) : null}

				{docsToSHow.count > 0 ? (
					docsToSHow.data.map((item, i) => (
						<div
							key={item.id}
							className="conceptLoaded row divElementBorder mb-2 mt-4"
							onMouseOver={(e) => {
								if (showingCommentBox === true) {
									return
								}
								e.preventDefault()
								setItemId(item.id)
							}}
							onMouseLeave={(e) => {
								if (showingCommentBox === true) {
									return
								}
								e.preventDefault()
								setItemId("")
							}}
							style={
								showingCommentBox === false
									? item.id === itemId
										? { borderBottom: "1px solid black", background: "beige", zIndex: 2 }
										: null
									: item.id === itemId
									? { position: "relative", zIndex: 1 }
									: { position: "relative", zIndex: -1 }
							}
							data-cy="document_from_list"
						>
							<div className="col-12 d-flex  divElement">
								<div
									className="col-3 divBlock"
									// dangerouslySetInnerHTML={operationsHelper.getDocumentType(item.source)}
									dangerouslySetInnerHTML={sourceHelper.getsource(item.source)}
								></div>
								<div className="col-3 divBlock">
									<span style={{ fontSize: "10px" }}>
										{item.hasOwnProperty("tagged_date") && item.tagged_date !== null
											? new Date(item.tagged_date).toLocaleString("en-US", {
													year: "numeric",
													month: "long",
													day: "2-digit",
											  })
											: new Date(item.creation_time).toLocaleString("en-US", {
													year: "numeric",
													month: "long",
													day: "2-digit",
											  })}
									</span>
								</div>
							</div>
							<div className="col-12 divElement mt-2" display="none" style={{ position: "relative", zIndex: "1" }}>
								<div className="divBlock" style={{ position: "relative", zIndex: "1" }}>
									{activeCheckbox ? (
										<input
											key={`bulk_checkbox_${item.id}`}
											type="checkbox"
											checked={bulkChecked[i]}
											className="form-check-input"
											onChange={(e) => {
												e.preventDefault()
												handleChange(i)
											}}
											onClick={(e) => {
												e.preventDefault()
												updateDocumentsBulk(item.id, item.title)
											}}
										></input>
									) : null}
								</div>
								<div
									id={item.id}
									className="col-8 divBlock relativo"
									style={{ cursor: "pointer", position: "relative", zIndex: "1" }}
									onClick={(e) => {
										e.preventDefault()
										if (showingCommentBox === true || e.target.className.includes("comentario-icon")) {
											return
										}
										timer = setTimeout(function () {
											if (!prevent) {
												handleOpen()
												/*setItem({
                                            idItem: item.id,
                                            contentItem: item.content,
                                            source: item.source,
                                            title: item.title,
                                            date: (item.hasOwnProperty('tagged_date') &&  item.tagged_date !==null && item.tagged_date !== undefined ? item.tagged_date : Math.floor(Date.now() / 1000) )
                                        });

                                        

                                        getDocumentContent(item.id, item.content);*/
												//updateCommentList(item.id);
												setShowingCommentBoxId(item.id)
												getDocumentContent(item.id, item.content)
												handleRecordClick(item.id)
											}
											prevent = false
										}, delay)
									}}
									onDoubleClick={(e) => {
										e.preventDefault()
										if (showingCommentBox === true || e.target.className.includes("comentario-icon")) {
											return
										}
										clearTimeout(timer)
										prevent = true
										setItem({
											idItem: item.id,
											contentItem: item.content,
											source: item.source,
											date:
												item.hasOwnProperty("tagged_date") &&
												item.tagged_date !== null &&
												item.tagged_date !== undefined
													? item.tagged_date
													: Math.floor(Date.now() / 1000),
											commentsCount: getCommentsCount(item.comments),
											comments: item.comments,
										})
										dispatch(documentsActions.downloadDocumentAction(item.id, item.file_name, item.source))
									}}
								>
									{item?.attachments > 0 && (
										<i
											className="bi bi-paperclip attachments"
											title={`${item?.attachments} attachment${item?.attachments > 1 ? "s" : ""}`}
										></i>
									)}
									<span className="font-12 px-2" style={{ position: "relative", zIndex: "1" }}>
										{item?.id && (
											<div
												id={`doc_id_${item.id}`}
												className="box"
												style={{
													backgroundColor: item?.tags
														? operationsHelper.getTagColor(item?.tags, tagsApi)
														: "#E2E2E2",
												}}
											></div>
										)}
										<strong>{item.title}</strong>
									</span>

									<br style={{ position: "relative", zIndex: "1" }}></br>
									<span style={{ position: "relative", zIndex: "1" }}>{item.filepath}</span>
								</div>

								{item.id === itemId ? (
									<div className="col-3 divBlockRight">
										<div className="col-12 divBlock">
											{selectIdentify.show ? (
												<div className="popup-selectIdentify" style={{ marginTop: "20px" }} ref={wrapperRef}>
													<ul>
														{tagsApi && tagsApi.hasOwnProperty("tags")
															? tagsApi.tags.map((element, i) => (
																	<li
																		key={`tag_A_${element.id}`}
																		data-cy={element.name}
																		onClick={(e) => {
																			let tag_id = element.id
																			let elementId = item.id
																			let color = element.color_id
																			updateSelectIdentify(tag_id, elementId)
																		}}
																		onMouseOver={(e) => {
																			e.preventDefault()
																			setSelectOver(i + 1)
																		}}
																		onMouseOut={(e) => {
																			e.preventDefault()
																			setSelectOver(false)
																		}}
																		style={
																			selectOver === i + 1
																				? { backgroundColor: "lightgray", cursor: "pointer" }
																				: { cursor: "pointer" }
																		}
																	>
																		<div
																			className="box"
																			style={{ backgroundColor: item.color_id }}
																		></div>
																		<span className="ml-10">{item.name}</span>
																	</li>
															  ))
															: null}
													</ul>
												</div>
											) : null}
											<div className="col-4 divBlock d-flex justify-content-center">
												{/*<i class="bi bi-check2-circle"></i>*/}
												<TagsUpdateDropdown idItem={item.id} updateSelectIdentify={updateSelectIdentify} />
											</div>
											<div className="divBlock hide">
												<a href="/#" className="ml-1 mr-1 font-12">
													Print
												</a>
											</div>
											<div className="col-5 divBlock d-flex justify-content-center">
												<a
													data-cy="download_doc"
													href="/#"
													className="ml-1 mr-1 font-12"
													style={{
														textDecoration: "none",
														display: "flex",
														pointerEvents:
															item.hasOwnProperty("id") &&
															downloadDocs.hasOwnProperty(item.id) &&
															downloadDocs[item.id].downloading === true
																? "none"
																: "",
													}}
													onClick={(e) => {
														e.preventDefault()
														dispatch(
															documentsActions.downloadDocumentAction(item.id, item.file_name, item.source)
														)
													}}
												>
													{item.hasOwnProperty("id") &&
													downloadDocs.hasOwnProperty(item.id) &&
													downloadDocs[item.id].downloading === true ? (
														<div>
															<div
																className="spinner-border text-dark"
																role="status"
																style={{ width: "15px", height: "15px" }}
															>
																<span className="visually-hidden">Loading...</span>
															</div>
														</div>
													) : (
														<>
															<i className="bi bi-download"></i>{" "}
															<span style={{ marginLeft: "5px" }}>Download</span>
														</>
													)}
													{item.hasOwnProperty("id") &&
													downloadDocs.hasOwnProperty(item.id) &&
													downloadDocs[item.id].downloading === true ? (
														<>
															<span style={{ marginLeft: "5px" }}>Downloading...</span>
															{/* <span className="percentage"> ({downloadDocs[item.id].percentage}%)</span> */}
														</>
													) : null}
												</a>
											</div>
											{/* <div className="col-3 divBlock d-flex justify-content-center">
                                        <a href={`mailto:?subject=Anzyz Project – Shared Document&body=Please, download this set of documents: ${window.location.protocol}//${window.location.host}/downloads?downloads=${item.id}`} className="ml-1 mr-1 font-12"
                                        
                                        >Share</a>
                                    </div> */}
											<div className="col-3 divBlock d-flex justify-content-center">
												<i
													className="fas fa-solid fa-comment comentario-icon"
													onClick={(e) => {
														e.preventDefault()
														setShowingCommentBox(true)
														updateCommentList(item.id)
														setShowingCommentBoxId(item.id)
													}}
												>
													<span style={{ fontSize: "12px", verticalAlign: "middel" }}>
														{comentsCount && comentsCount.hasOwnProperty(item?.id)
															? comentsCount[item?.id]
															: item.comments_count}
													</span>
												</i>
												<CommentsList
													showingCommentBoxId={showingCommentBoxId}
													setShowingCommentBox={setShowingCommentBox}
													item={item}
													commentList={commentList}
													idElement={idElement}
													setIdElement={setIdElement}
													setShowingCommentBoxId={setShowingCommentBoxId}
												/>
											</div>
										</div>
									</div>
								) : null}
							</div>
						</div>
					))
				) : globalStateSearchDocumentList.data.length === 0 ? (
					<div data-cy="no-results" className="ml-10 mt-20">
						<h6>No results retrieved</h6>
					</div>
				) : null}

				<Pagination
					currentpage={currentpage}
					prevPage={prevPage}
					totalpages={totalpages}
					docsToSHow={docsToSHow}
					nextPage={nextPage}
					setCurrentPage={setCurrentPage}
					setDocumentsBulk={setDocumentsBulk}
					setAllChecked={setAllChecked}
				/>
				{/* <div className="col-12 d-flex justify-content-center mt-20">
                  {(currentpage === 1) ? null : (
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{marginRight: '2px'}}
                      onClick={prevPage}
                    >
                      &laquo; Prev
                    </button>
                  )}

                  {(currentpage === totalpages || Number.isNaN(totalpages) || (docsToSHow.count===0)) ? null : (
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{marginLeft: '2px'}}
                      onClick={nextPage}
                    >
                      Next &raquo;
                    </button>
                  )}  
            </div> */}

				<div data-cy="element_modal">
					<DocumentModal
						open={open}
						handleClose={handleClose}
						selectDateDocument={selectDateDocument}
						wrapperRef={wrapperRef}
						updateSelectDateDocument={updateSelectDateDocument}
						updateSelectIdentify={updateSelectIdentify}
						updateDateDocument={updateDateDocument}
						showSelectDateDocument={showSelectDateDocument}
						maskHighlight={maskHightlight}
						moveToHighlight={moveToHightlight}
					/>
					{/* <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <div id="element_modal" style={modalStyle} className={classes.paper}>
                        <div className="col-12 divBlockModal" style={{backgroundColor: 'white'}}>
                                    {selectDateDocument.show ? 
                                        <div className="selectDateDocument" ref={wrapperRef}>
                                            <ul>
                                                <li>
                                                    <span style={{fontSize: '13px'}}><strong>Actual date: </strong></span>
                                                    <br></br>
                                                    <span style={{fontSize: '14px'}}> 
                                                        {
                                                            // new Intl.DateTimeFormat('en-US', {
                                                            //     year: 'numeric',
                                                            //     month: 'long',
                                                            //     day: '2-digit'
                                                            // }).format(item.date)

                                                            new Date(item.date).toLocaleString('en-US', {
                                                                year: 'numeric',
                                                                month: 'long',
                                                                day: '2-digit'
                                                            })
                                                        }
                                                        
                                                    </span>
                                                </li>
                                                <li>
                                                    <span style={{fontSize: '13px'}}><strong>New date: </strong></span>
                                                    <br></br>
                                                    <form 
                                                        className="d-flex justify-content-center"
                                                        onSubmit={updateDateDocument}
                                                    >
                                                        <input
                                                            type='date'
                                                            name='date'
                                                            onChange={updateSelectDateDocument}
                                                            data-cy="date_document_input"
                                                        />
                                                        <button 
                                                            type='submit'
                                                            className={selectDateDocument.date ? "btn btn-primary btn-sm" : "btn btn-primary btn-sm disabled"}
                                                            style={{marginLeft: '10px'}}
                                                            data-cy="update_modal_button"
                                                        >
                                                            Update
                                                        </button>
                                                    </form>
                                                </li>
                                            </ul>
                                            
                                        </div>
                                    : null}


                            <div className="col-12 d-flex justify-content-center">

                            <div className="col-3 divBlock d-flex justify-content-center">
                                    <a
                                        data-cy="highlight_modal_button" 
                                        onClick = {e =>{
                                            e.preventDefault();
                                            moveToHightlight();
                                        }}
                                        className="btnModal"
                                        style={{textDecoration: 'none'}}
                                    >
                                        <i className="bi bi-star"></i> Highlight
                                    </a>
                                </div>

                                <div className="col-3 divBlock d-flex justify-content-center">
                                 <DropdownButton id="dropdown-basic-button-detail" size="sm" title="Identify ">
                                 <Dropdown.Item href="#/action-1"
                                                key={`drop_B_0`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    let tag_id="";
                                                    let elementId=item.idItem;
                                                    let color = "white";
                                                    updateSelectIdentify(tag_id, elementId);
                                                }}
                                                >
                                                <div className="box  boxControl3" style={{backgroundColor: '#E2E2E2'}}></div>
                                                <span className="ml-10">Remove tag</span>
                                            </Dropdown.Item>
                                        {tagsApi && tagsApi.hasOwnProperty('tags') ? tagsApi.tags.map((element, i) => 
                                            <Dropdown.Item href="#/action-1"  key={`drop_B_${element.id}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    let tag_id=element.id;
                                                    let elementId=item.idItem;
                                                    let color = element.color_id;
                                                    updateSelectIdentify(tag_id, elementId);
                                                }}
                                            >
                                                <div className="box  boxControl3" style={{backgroundColor: element.color_id}}></div>
                                                <span className="ml-10">{element.name}</span>
                                            </Dropdown.Item>
                                        ) : null}
                                    </DropdownButton>
                                </div>
                                <div className="col-3 divBlock d-flex justify-content-center">
                                    <button
                                        data-cy="date_document_modal" 
                                        className="btnModal" 
                                        onClick={(e)=>{
                                            showSelectDateDocument(e);
                                        }}
                                    >
                                        <i className="bi bi-calendar-check"></i> Date document
                                    </button>
                                    
                                </div>
                                
                                <div className="col-3 divBlock d-flex justify-content-center">
                                    <button
                                        data-cy="download_modal_button" 
                                        className="btnModal"
                                        onClick={(e)=>{
                                            e.preventDefault();
                                            dispatch(documentsActions.downloadDocumentAction(item.idItem, content.file_name, item.source))
                                        }}
                                    >
                                        {downloadDocs.hasOwnProperty(item.idItem) && downloadDocs[item.idItem].downloading===true ?
                                            <div className="spinner-border text-dark" role="status" style={{width: '15px', height: '15px'}}>
                                                <span className="visually-hidden">Loading...</span>
                                            </div>
                                        :   
                                            <i className="bi bi-download"></i>
                                                            
                                        } Download    
                                            {downloadDocs.hasOwnProperty(item.idItem) && downloadDocs[item.idItem].downloading===true ?
                                                <span className="percentage"> ({downloadDocs[item.idItem].percentage}%)</span>
                                            :
                                                null
                                            }
                                    </button>
                                </div>
                            </div>
                            
                        </div>
                        
                        <div className="col-12 divBlockModal mt-1" style={{backgroundColor: 'white'}}>
                            {(content.errorDocumentText)? <p className="alert alert-danger">Error loading content for this document</p> : null} 
                            {content.documentText === null || content.documentId !== item.idItem && content.errorDocumentText === null ? 
                                <div className="col-12 d-flex justify-content-center mt-5 mb-5">
                                    <div className="d-flex align-items-center alert alert-warning">
                                        <strong className="loading">Loading...</strong>
                                        <div className="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                                    </div>
                                </div>
                            : null}
                            
                            <div>
                                <div id="divModal" className="divScroll divScrollMax655">
                                    {item.hasOwnProperty('source') ? 
                                        <MetadataLayout
                                            content={content} 
                                            item={item}
                                            maskHightlight={maskHightlight}
                                            >
                                        </MetadataLayout>
                                    : null }
                                     <p  id="document_content_div"
                                        dangerouslySetInnerHTML={maskHightlight(content.documentText,item.idItem)}
                                        ></p>

                                    
                          <CommentsDetailsModal
                          commentsCount={commentList.length}
                          commentList={commentList}
                          docId={item.idItem}
                          />


                                </div>
                            </div>
                        </div>
                        
                    </div>
                </Modal> */}
				</div>
			</Fragment>
		</div>
	)
}

export default ElementsListSearch
